import { render, staticRenderFns } from "./verifyCode.vue?vue&type=template&id=224975ea"
import script from "./verifyCode.vue?vue&type=script&lang=ts"
export * from "./verifyCode.vue?vue&type=script&lang=ts"
import style0 from "./verifyCode.vue?vue&type=style&index=0&id=224975ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports